// import  {userExists,createUser } from "./actions";
import store from "../../store";
import * as ACTIONS from "./actions";


const model = {
    /*===========*/
    userExists: (data) => store.dispatch(ACTIONS.userExists(data)),
    createNewUser: (data) => store.dispatch(ACTIONS.createNewUser(data)),
    getSignedGetProfileList: (data) => store.dispatch(ACTIONS.getSignedGetProfileList(data)),
    getAgreementsDetails: (data) => store.dispatch(ACTIONS.getAgreementsDetails(data)),
    createNewSaveAgreement: (data) => store.dispatch(ACTIONS.createNewSaveAgreement(data)),
    cancelAgreementUploadData: (data) => store.dispatch(ACTIONS.cancelAgreementUploadData(data)),
    getdashboardDetails: (data) => store.dispatch(ACTIONS.getdashboardDetails(data)),
    getUserInfoList: (query) => store.dispatch(ACTIONS.getUserInfoList(query)),
    getEditAgreementDetails: (agreementId) => store.dispatch(ACTIONS.getEditAgreementDetails(agreementId)),
    sendAgreementAction: (data) => store.dispatch(ACTIONS.sendAgreementAction(data)),
    downloadAgreementFile: (id) => store.dispatch(ACTIONS.downloadAgreementFile(id)),
    previewAgreement: (id) => store.dispatch(ACTIONS.previewAgreementAction(id)),
};


export default model;

